import { ZipcodeInput } from '@fmm/react-encompass-inputs';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useAutosavingFormContext } from 'src/components/ConnectedInputs/AutosavingForm';
import PropTypes from 'prop-types';
import { POSTALCODE_REGEX } from 'src/util';

export const ConnectedZipcodeInput = React.forwardRef(
  ({ name, rules, required, id, ...props }, ref) => {
    const { id: contextId } = useAutosavingFormContext();
    return (
      <Controller
        name={name}
        rules={{
          required,
          pattern: {
            value: POSTALCODE_REGEX,
            message: 'Please enter a valid postal code',
          },
          ...rules,
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { invalid, error },
        }) => (
          <ZipcodeInput
            id={(id ?? contextId) ? `${contextId}.${name}` : name}
            fullWidth
            {...props}
            name={name}
            value={value || ''}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onBlur={onBlur}
            ref={ref}
            error={invalid}
            helperText={error?.message}
            required={Boolean(required || rules?.required)}
          />
        )}
      />
    );
  },
);

ConnectedZipcodeInput.displayName = 'ConnectedZipcodeInput';
ConnectedZipcodeInput.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  id: PropTypes.string,
};
export default ConnectedZipcodeInput;
